import React from 'react';
import {
    View,
    Text,
    StyleSheet,
    ScrollView,
} from 'react-native';
import Header from '../../../commonComponents/Header';
import {SafeAreaView} from 'react-native-safe-area-context';
import {
    globalConfigurableData,
} from '../../../utils/globalConstant';
import {globalFontStyle} from "../../../assets";

const StaticBanner = ({navigation, route}) => {
    const staticData = route.params;

    return (
        <SafeAreaView
            style={{
                flex: 1,
            }}>
                <Header
                    isInternalPage={false}
                    navigation={navigation}
                    pageName={""}
                    backGroundColor={globalConfigurableData.headerColor}
                    isCheckGoBack={true}
                />
            <ScrollView
                style={{
                    paddingHorizontal: 16,
                    backgroundColor: globalConfigurableData.globalThemeColor,
                }}
                showsVerticalScrollIndicator={false}>
                <Text style={{
                    ...globalFontStyle.appFontHeading,
                    color: globalConfigurableData.primaryTextColor1,
                    marginTop: 25
                }}>
                    {staticData?.title}
                </Text>
                <Text style={{
                    ...globalFontStyle.appFontBody,
                    color: globalConfigurableData.secondaryTextColor1,
                    marginTop: 15,
                    marginBottom: 10
                }}>
                    {staticData?.description}
                </Text>
                {staticData?.metaData?.map((item, i) => {
                    return (
                        <View style={{flexDirection: "row", marginTop: 5}}>
                            <Text style={{
                                ...globalFontStyle.appFontBody,
                                color: globalConfigurableData.secondaryTextColor1,
                                marginHorizontal: 6
                            }}>{"•"}</Text>
                            <Text style={{
                                ...globalFontStyle.appFontBody,
                                color: globalConfigurableData.secondaryTextColor1,
                            }}>{item}</Text>
                        </View>

                    );
                })}
            </ScrollView>
        </SafeAreaView>
    );
};

export default StaticBanner;

const styles = StyleSheet.create({});
